var _a;
import { UrlMappingsKeys } from '../url-mappings-keys';
export var challengesMapping = (_a = {},
    _a[UrlMappingsKeys.CHALLENGES_PAGE] = {
        variables: ['slug'],
        required: ['slug'],
        defaultPrefix: 'challenge-page',
    },
    _a);
//# sourceMappingURL=challenges.js.map